import { getS3ObjectURLShared } from '@shared/utils/helpers/s3';

export const getS3ObjectURL = (key: string) => {
  const prefix = process.env.NEXT_PUBLIC_CDN_URL;
  if (!prefix) {
    throw new Error('NEXT_PUBLIC_CDN_URL environment variable is not defined');
  }
  return getS3ObjectURLShared(key, prefix);
};
